import React from 'react';

const BannersContext = React.createContext({});

export const BannersProvider = BannersContext.Provider;
export const BannersConsumer = BannersContext.Consumer;
export default BannersContext;
